import request from '@/shared/api/request';

export const resetDatabasePassword = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'reset_password' },
  });
